import { Component, Input } from '@angular/core'

import { ChannelSourcesViewService } from '../../data/services/view/channel-sources-view.service'
import { IClientEvent } from '../../data/interfaces/client-event.interface'
import { clientEventMeta, LOSS_REASON_LABELS } from '../../data/constants/client-event-type.constant'

@Component({
  selector: 'app-timeline-event-item',
  templateUrl: './timeline-event-item.component.html',
  styleUrls: ['./timeline-event-item.component.scss'],
})
export class TimelineEventItemComponent {
  @Input() event!: IClientEvent

  constructor(private channels: ChannelSourcesViewService) {}

  get label(): string {
    return clientEventMeta(this.event.type).label
  }

  get channelLabel(): string | null {
    if (!this.event.channelKey) return null
    return this.channels.getByKey(this.event.channelKey)?.label ?? this.event.channelKey
  }

  get actor(): string {
    if (this.event.actorEntity === 'system') return 'Sistema'
    // Preferir el nombre propio del actor (snapshot backend); rol/fallback solo si no resolvió.
    if (this.event.actorName) return this.event.actorName
    if (this.event.actorEntity === 'Client') return 'Cliente'
    return this.event.actorRole ?? 'Usuario interno'
  }

  get lossReasonLabel(): string | null {
    const reason = this.event.payload?.['reason']
    if (!reason) return null
    return LOSS_REASON_LABELS[reason] ?? reason
  }

  // Detalle de una reasignación de vendedor/broker: "de [Anterior] a [Nuevo]".
  get assignmentDetail(): string | null {
    if (this.event.type !== 'client.seller_reassigned' && this.event.type !== 'client.broker_reassigned') return null
    const fromName = this.event.payload?.['from']?.name ?? null
    const toName = this.event.payload?.['to']?.name ?? null
    if (fromName && toName) return `de ${fromName} a ${toName}`
    if (!fromName && toName) return `asignado a ${toName}`
    if (fromName && !toName) return `removido: ${fromName}`
    return null
  }
}
